import {
  type OpportunitiesSearchFilters,
  type OpportunitiesSearchOptions,
} from "@repo/api";

const SESSION_STORAGE_KEY = "saleslead-projectSearchFilters";

const defaultSearchFilters: FiltersFromSessionStorage = {
  term: undefined,
  sortKey: "opportunityId",
  sortOrder: "desc",
};
interface FiltersFromSessionStorage {
  term: OpportunitiesSearchFilters["term"];
  sortKey: OpportunitiesSearchOptions["sortKey"];
  sortOrder: OpportunitiesSearchOptions["sortOrder"];
}

export const getFiltersFromSessionStorage = () => {
  const res = window.sessionStorage.getItem(SESSION_STORAGE_KEY);

  if (!res) {
    return defaultSearchFilters;
  }
  return JSON.parse(res) as FiltersFromSessionStorage;
};

export const addFiltersToSessionStorage = (
  filters: Partial<FiltersFromSessionStorage>
) => {
  const filtersFromSessionStorage = getFiltersFromSessionStorage();
  const newFilters = { ...filtersFromSessionStorage, ...filters };
  window.sessionStorage.setItem(
    SESSION_STORAGE_KEY,
    JSON.stringify(newFilters)
  );
};
